import DefaultMD from "./default.md";
import SignUpMD from "./sign-up.md";
import LoanApplicationMD from "./loan-application.md";

export const Default = DefaultMD;
export const SignUp = SignUpMD;
export const LoanApplication = LoanApplicationMD;
